export const TERMINAL_EXECUTION_STATES = new Set([
  'completed',
  'interrupted',
  'cancelled',
  'failed',
  'failed_to_cancel',
])

export function isTerminalExecutionState(state: unknown): boolean {
  return typeof state === 'string' && TERMINAL_EXECUTION_STATES.has(state)
}

export function completionLedgerKey(taskId: string, turnId?: string | null): string {
  return `${taskId}:${turnId || 'unknown'}`
}

export function shouldRunCompletionSideEffects(ledger: Set<string>, taskId: string, turnId?: string | null): boolean {
  const key = completionLedgerKey(taskId, turnId)
  if (ledger.has(key)) return false
  ledger.add(key)
  return true
}
